var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('portal-navbar'),_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view',{staticClass:"px-4 py-4"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }